import { render, staticRenderFns } from "./pc-part-2.vue?vue&type=template&id=de64a1c8&scoped=true"
import script from "./pc-part-2.vue?vue&type=script&lang=js"
export * from "./pc-part-2.vue?vue&type=script&lang=js"
import style0 from "./pc-part-2.vue?vue&type=style&index=0&id=de64a1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de64a1c8",
  null
  
)

export default component.exports